



























































































import {Component, Prop, Vue} from "vue-property-decorator";
import PxTextEntryBox from "@/views/components/input/formFields/PxTextEntryBox.vue";
import PxTextArea from "@/views/components/input/formFields/PxTextArea.vue";
import PxDropdown from "@/views/components/input/formFields/PxDropdown.vue";
import PxNumberInput from "@/views/components/input/formFields/PxNumberInput.vue";

import {structureStore} from "@/store/store";
import SeasonRow from "@/modules/perRoad/views/components/SeasonRow.vue";
import {UnitSystem} from "@/interfaces/units";
import {createStructureValidations} from "@/modules/structure/lib/validations";
import PrLayerEditor from "@/modules/perRoad/views/components/structure/PrLayerEditor.vue";
import StructureLayerEditor from "@/modules/structure/views/StructureLayerEditor.vue";
import InspectorThreeJS from "@/modules/perRoad/views/components/inspection/InspectorThreeJS.vue";
import CriticalLocationDepthInspector
  from "@/modules/perRoad/views/components/inspection/CriticalLocationDepthInspector.vue";
import {
  convertDeterministicLayersImperial,
  convertDeterministicLayersMetric
} from "@/modules/structure/lib/convertLayers";

Component.registerHooks(["validations"]);

@Component({
  components: {
    CriticalLocationDepthInspector,
    InspectorThreeJS,
    StructureLayerEditor,
    PrLayerEditor,
    SeasonRow,
    PxNumberInput,
    PxTextEntryBox,
    PxTextArea,
    PxDropdown,
  },
})
export default class PavementStructureLayers extends Vue {
  @Prop() readonly id!: string;

  @Prop() readonly page!: number;


  plotKey = 0;

  newLayer(n: number, event: any) {
    this.scenario.structureLayers.splice(n, 1, event);
    this.sync();
  }

  get scenario() {
    return structureStore.currentScenario;
  }

  get scenarioImperial() {
    return structureStore.currentImperial;
  }

  get isImperial() {
    return this.scenario.unitSystem === UnitSystem.Imperial;
  }

  get simulatedLayers() {
    this.plotKey += 1;
    console.log("creating sim layers");
    if (this.scenario.unitSystem === UnitSystem.Imperial) {
      return convertDeterministicLayersImperial(this.scenario.structureLayers);
    } else {
      return convertDeterministicLayersMetric(this.scenario.structureLayers);
    }
  }

  incrementPlotKey() {
    this.plotKey += 1;
  }

  sync() {
    structureStore.setCurrentScenario(this.scenario);
    this.incrementPlotKey();
  }

  save() {
    this.sync();
    structureStore.saveCurrentScenario();
  }

  validations() {
    return createStructureValidations(this.scenarioImperial, this.page);
  }

  mounted() {
    // structureStore.setCurrentScenario(createNewPavementStructureScenario(userStore.user, projectStore.currentProjectId));
  }
}

